import React, { FC } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { MasterLayout } from '../../rbts/layout/MasterLayout';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper';


const Routes: FC = () => {
  return (
    <Switch>
      {/* Mantén el querystring al saltar a /dashboard */}
      <Route exact path="/">
        {({ location }) => (
          <Redirect to={{ pathname: '/embed', search: location.search }} />
        )}
      </Route>

      <Route path="/error" component={ErrorsPage} />

      {/* SOLO dashboard dentro del layout */}
      <Route
        path="/embed"
        render={() => (
          <MasterLayout>
            <DashboardWrapper />
          </MasterLayout>
        )}
      />

      {/* Catch-all preservando search */}
      <Route>
        {({ location }) => (
          <Redirect to={{ pathname: '/embed', search: location.search }} />
        )}
      </Route>
    </Switch>
  );
};

export { Routes };
